import React, {ReactNode, useEffect, useMemo, useState} from 'react';
import {Textarea as HInput, TextareaProps as HInputProps} from '@headlessui/react';
import {useFormContext} from 'react-hook-form';
import {RegisterOptions} from 'react-hook-form/dist/types/validator';
import clsx from 'clsx';
import styles from '@ui/Input/Input.module.scss';

type TextAreaProps = HInputProps & {
    title?: string
    forceHover?: boolean
    forceFocus?: boolean
    validate?: RegisterOptions<any, any>
    suffix?: ReactNode | undefined,
};

export const TextArea = ({
                          className: _className,
                          title,
                          forceHover = false,
                          forceFocus = false,
                          placeholder,
                          validate,
                          suffix,
                          ...props
                      }: TextAreaProps) => {
    const compact = true;
    const name = props.name || '';
    const form = useFormContext();

    const [, setTap] = useState(false);
    const [focus, setFocus] = useState(false);
    const hasValue = useMemo(() => !!form.watch(name), [!!form.watch(name)]);
    const hasFocus = focus || forceFocus;

    // хак для рефреша проверки наличия зачения
    useEffect(() => {
        requestAnimationFrame(() => setTap(true));
    }, []);

    const errors = {
        ...(form.formState.errors[name] || {}),
        ...(form.getFieldState(name).error || {}),
    };


    return <div className={`d-flex flex-column ${_className}`}>
        <div className={`t4 p-relative click-through ${styles.ControlTitleOuter}`}>
            <span className={clsx({
                t2: !hasFocus && !hasValue,
                t4: hasFocus || hasValue,
                [styles.elevated]: hasFocus || hasValue,
            }, styles.ControlTitle)}>
                {title}
                {props.required && <span className='text-negative-100'>&nbsp;*</span>}
            </span>
        </div>
        <label
            className={clsx({
                [styles.ControlCompact]: compact,
                [styles.ControlNormal]: !compact,
                [styles.focus]: hasFocus,
                [styles.hover]: forceHover,
                [styles.error]: Object.keys(errors).length > 0,
                [styles.disabled]: props.disabled || props.readOnly,
            }, `d-block ${styles.ControlBase}`)}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
        >
            <div className='d-flex align-items-center gap-6'>
                <div className='d-flex flex-column flex-grow-1'>
                    <HInput
                        className={clsx({}, `flex-grow-1 ${styles.input}`)}
                        // ref={ref}
                        placeholder={hasFocus ? placeholder : ''}
                        {...props}
                        {...form.register(name, {required: props.required, ...validate})}
                    />
                </div>
                {suffix}
            </div>
        </label>
        <span className='t4 text-negative-100'>
            {errors.type === 'maxLength' && ((errors.message as any) || `Максимум ${validate?.maxLength} знаков`)}
            {errors.type === 'minLength' && ((errors.message as any) || `Минимум ${validate?.maxLength} знаков`)}
            {errors.type === 'required' && ((errors.message as any) || 'Обязаельное поле')}
            {errors.type === 'pattern' && ((errors.message as any) || 'Неверный формат')}
            {errors.type === 'max' && ((errors.message as any) || `Максимум ${validate?.maxLength}`)}
            {errors.type === 'min' && ((errors.message as any) || `Минимум ${validate?.maxLength}`)}
            {errors.type === 'validate' && (errors.message as any)}
            {(errors as any)[0]}
        </span>
    </div>;
};
